import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';

import { Grid } from '@mui/material';

import { Button, Loading, Pill } from 'Components';
import Preferences from 'Core/containers/Preferences';
import { NotificationManager } from 'Components/Notifications';

import {
    mapGeofencesVisibleGetTags,
    getPreferences,
    mapGeofencesUpdatePreference
} from 'Redux/actions';

import styles from 'Assets/sass/core/vars.scss';
import './styles.scss';

const GeofenceVisibleTags = (props) => {
    const dispatch = useDispatch();
    const { intl } = props;
    const { messages } = intl;

    const preferencesRef = useRef();
    const [selectedGeofenceTags, setSelectedGeofenceTags] = useState([]);
    const [preferences, setPreferences] = useState();
    const preferencesKey = 'realtimeMaps';

    const { geofenceTags, geofenceTagsLoading } = useSelector((state) => state.realtimeMapNewGeofenceModuleRedux);

    const contPreference = useSelector((state) => state.realtimeMapGeofenceVisibleTagsAssignRedux.contPreference);
    const loadingPreference = useSelector(state => state.preferencesRedux.loadingPreference);

    const {
        user,
        authenticatedId,
    } = useSelector((state) => state.securityRedux);

    useEffect(() => {
        dispatch(getPreferences({ entityName: "User", entityId: authenticatedId }));
    }, [])

    useEffect(() => {
        if (geofenceTags && geofenceTags.length && preferences?.hiddenGeofenceGroups) {
            initTags(preferences?.hiddenGeofenceGroups);
        } else if (geofenceTags && geofenceTags.length && !preferences?.hiddenGeofenceGroups) {
            setSelectedGeofenceTags([...geofenceTags]);
        }
    }, [geofenceTags, preferences?.hiddenGeofenceGroups]);

    const onSelectLandmarkTag = useCallback((item) => {
        let objectTags = [...selectedGeofenceTags];
        if (item?.id === 0) {
            if (selectedGeofenceTags.length === geofenceTags.length) {
                objectTags = [];
            } else {
                objectTags = [...geofenceTags];
            }
        } else {
            if (objectTags.find(tag => tag.id === item.id)) {
                objectTags = selectedGeofenceTags.filter(tag => tag.id !== item.id);
            } else {
                objectTags.push(item);
            }
        }

        setSelectedGeofenceTags(objectTags);
    });

    const save = useCallback(() => {
        if (authenticatedId) {
            let ids = selectedGeofenceTags.map(tag => {
                return tag.id;
            });

            let newHiddentTags = geofenceTags.filter(tag => !ids.includes(tag.id));
            const newPreferences = {
                ...preferences,
                hiddenGeofenceGroups: newHiddentTags.map(hiddenLandmarkTag => {
                    return hiddenLandmarkTag.id;
                })
            }
            setPreferences(newPreferences)
            preferencesRef?.current?.savePreference("User", preferencesKey, newPreferences)
        }

        NotificationManager.success(
            messages['mapGeofenceVisibleTags_success'],
            messages['success'],
            3000,
            null,
            null,
            'warning',
        );

        //update the preferences for another modules
        dispatch(mapGeofencesUpdatePreference())

    });

    const initTags = useCallback((hiddenTags) => {
        if (hiddenTags) {
            let newSelectedLandmarkTags = geofenceTags.filter(tag => !hiddenTags.includes(tag?.id));
            setSelectedGeofenceTags(newSelectedLandmarkTags);
        }
    });

    const selectedStyle = {
        width: '100%',
        backgroundColor: styles.blue,
        color: "white",
        border: `1px solid ${styles.blue}`
    };

    const defaultStyle = {
        width: '100%',
        backgroundColor: "#F1F1F1",
        color: "#484848",
        border: "1px solid #F1F1F1"
    };

    return (
        <div className="geofence-visible-groups-container">
            <Preferences
                ref={preferencesRef}
                preferencesKey={preferencesKey}
                onInitialPreferences={(paramPreferences) => {
                    //dispatch(mapGeofencesVisibleGetTags());
                    if (!preferences)
                        setPreferences(paramPreferences);
                }}
            >
                {
                    geofenceTagsLoading ?
                        <div style={{ padding: 20 }}><Loading full /></div> :
                        <div
                            style={{
                                height: "calc(100vh - 360px)",
                                overflow: "hidden auto"
                            }}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                                spacing={1}

                            >
                                <Grid item xs={6}>
                                    <Pill
                                        item={{ id: 0, name: selectedGeofenceTags?.length === geofenceTags?.length ? messages['mapGeofenceVisibleTags_unselectAll'] : messages['mapGeofenceVisibleTags_selectAll'] }}
                                        style={defaultStyle}
                                        outlined={false}
                                        onClick={(value) => {
                                            onSelectLandmarkTag(value);
                                        }}
                                    />
                                </Grid>

                                {
                                    geofenceTags.map((tag, index) => {
                                        let selected = selectedGeofenceTags.find(selectedLandmarkGroup => selectedLandmarkGroup.id === tag.id);
                                        return (
                                            <Grid item xs={6} key={index}>
                                                <Pill
                                                    item={tag}
                                                    outlined={false}
                                                    style={selected ? selectedStyle : defaultStyle}
                                                    onClick={(value) => {
                                                        onSelectLandmarkTag(value);
                                                    }}
                                                />
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                        </div>
                }

            </Preferences>

            <div className="geofence-visible-groups-footer">
                <Button
                    disabled={false}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        initTags(preferences?.hiddenGeofenceGroups);
                    }}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={!selectedGeofenceTags.length}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        save();
                    }}
                    className="btn-blue"
                >
                    {messages['save']}
                </Button>
            </div>
        </div>
    )
}

export default injectIntl(GeofenceVisibleTags);